module.exports = __webpack_public_path__ + "img/home1.c711bc6f.png";